import * as React from 'react';
import { UIComponentState, UIComponentHandler, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { ProfiletunesCategoryComponentProps } from './profiletunescomponent';
import { ProfiletunesCategoryCSSStyle } from './profiletunescss';
import { ToneDto } from '../../../../core/dto/tonedto';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { GridComponent, GridComponentProps } from '../../../toolkit/grid/gridcomponent';
import { FeaturedCategoryListCSSStyle, FeaturedCategoryListCSSStyleImpl } from '../featuredcategory/list/featuredcategorylistcss';
import { ListViewModel } from '../../../toolkit/horizontallist/listviewmodel';
import { ProfileTuneViewModelImpl } from './profiletunecard/profiletuneviewmodel';
// import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import "./profiletunes-titles-style.css";
import { AudioPlayerWithProgressImpl } from '../../../toolkit/player/playerwithprogress/playerwithprogressimpl';


export class ProfiletunesCategoryViewImpl extends UIComponentViewImpl<UIDataModel> {
    private ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;
    private profiletunesCssStyle: FeaturedCategoryListCSSStyle;
    private isShowMore: boolean = false;
    private toneDtoList: ToneDto[];
    private listViewModel: ListViewModel<ToneDto>;
    private audioPlayerWithProgress: AudioPlayerWithProgressImpl;


    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(context, uiComponentHandler);

        this.profiletunesCssStyle = new FeaturedCategoryListCSSStyleImpl(context);

        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

        this.listViewModel = new ProfileTuneViewModelImpl(
            context.getConfigurationSettings().getProperty("FETCH_LIMIT"), context, "40px", this.audioPlayerWithProgress
        );
    }

    bindHandlers() {
        this.showMore = this.showMore.bind(this);
        this.showLess = this.showLess.bind(this);
    }

    draw(props: ProfiletunesCategoryComponentProps, state: UIComponentState, profiletunesCssStyle: ProfiletunesCategoryCSSStyle): JSX.Element {
        super.draw(props, state, profiletunesCssStyle);
        return (
            <>
                <div id="profiletunes-titles-wrapper">
                    {
                        this.getWebView()
                    }
                </div>
                <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.listViewModel} context={this.getContext()} />
            </>);
    }

    showMore() {
        if (this.toneDtoList !== undefined) {
            if (this.toneDtoList.length > 10) {

                this.getUIProps().context.getRedirectionHandler().routeNextFeature(
                    RoutingFeatures.PROFILE_TUNES, false);
            }
            else {
                this.isShowMore = false;
                this.listViewModel.setListDatas(this.toneDtoList);
                this.getUIComponentHandler().forceUpdateComponent();
            }
        }
    }

    showLess() {

        if (this.toneDtoList !== undefined) {
            this.isShowMore = true;
            // let filteredToneDtos: ToneDto[] = [];

            // this.toneDtoList.forEach((toneDto1: ToneDto, index: number) => {
            //     (index <= 7) && filteredToneDtos.push(toneDto1);
            // });
            this.listViewModel.setListDatas(this.toneDtoList.slice(0, 5));
            this.getUIComponentHandler().forceUpdateComponent();
        }
    }

    getWebView() {
        return (
            <>
                <div id="profiletunes-category-main-div" style={{}}>
                    <div id="profiletunes-category-title-div" style={{}}>
                        <label id="profiletunes-category-title-label" style={this.profiletunesCssStyle.getTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.profile_tunes)}</label>
                    </div>
                    {this.isShowMore && <div style={{ flex: 0.5, textAlign: "right", justifyContent: "flex-end", marginTop: "58px" }}>
                        <label id="#profiletunes-category-showmore-label" onClick={this.showMore} style={this.profiletunesCssStyle.getShowMoreCSSStyle()}>{this.getContext().getResources().getString(Strings.show_more)}</label>
                    </div>}
                    {!this.isShowMore && <div style={{ flex: 0.5, textAlign: "right", justifyContent: "flex-end" }}>
                        <label id="#profiletunes-category-showmore-label" onClick={this.showLess} style={this.profiletunesCssStyle.getShowMoreCSSStyle()}>{this.getContext().getResources().getString(Strings.show_less)}</label>
                    </div>}
                </div>
            </>
        );
    }

    /* getMobileView()
    {
        return (
            <>
            <div style={{display: "flex", flexFlow: "row wrap", width: "100%"}}>
                <div style={{flex: 0.8, textAlign: "left", justifyContent: "flex-start"}}>
                <label style={this.profiletunesCssStyle.getMobileTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.profile_tunes)}</label>
                </div>
                {this.isShowMore && <div style={{flex: 0.5, textAlign: "right", justifyContent: "flex-end"}}>
                    <label onClick={this.showMore} style={this.profiletunesCssStyle.getMobileShowMoreCSSStyle()}>{this.getContext().getResources().getString(Strings.show_more)}</label>
                </div>}
                {!this.isShowMore && <div style={{flex: 0.5, textAlign: "right", justifyContent: "flex-end"}}>
                    <label onClick={this.showLess} style={this.profiletunesCssStyle.getMobileShowMoreCSSStyle()}>{this.getContext().getResources().getString(Strings.show_less)}</label>
                </div>}
            </div>
            </>
        );
    } */
    updateData(listOfDatas: ToneDto[], isShowMore: boolean, scrollToPosition: number, isScrollToPositionRequired: boolean) {
        this.toneDtoList = listOfDatas;
        this.isShowMore = isShowMore;
        // this.listViewModel.getListOfDatas().length = 0;
        this.listViewModel.setListDatas(listOfDatas.slice(0, 5));
        this.listViewModel.setScrollToPosition(scrollToPosition, isScrollToPositionRequired);
        this.ref !== null && this.ref !== undefined && this.ref.forceUpdateComponent();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunesview.tsx